export const COLUMN_INDEX_CURRENCY_1 = 1;  
export const COLUMN_INDEX_CURRENCY_2 = 3; 
export const COLUMN_INDEX_CURRENCY_3 = 5;  
export const COLUMN_INDEX_CURRENCY_4 = 6;  
export const COLUMN_INDEX_CURRENCY_5 = 9;  
export const COLUMN_INDEX_CURRENCY_6 = 10; 

export const CURRENCY_COLUMNS = [
  COLUMN_INDEX_CURRENCY_1,
  COLUMN_INDEX_CURRENCY_2,
  COLUMN_INDEX_CURRENCY_3,
  COLUMN_INDEX_CURRENCY_4,
  COLUMN_INDEX_CURRENCY_5,
  COLUMN_INDEX_CURRENCY_6,
];